import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

import contact from '@/store/shared/contact'
import list from '@/store/shared/selectableList'
import search from '@/store/shared/search'

export default {
  namespaced: true,
  state () {
    return {
      document: undefined,
      tradeName: undefined,
      name: undefined,
      source: 'all',
      loaded: false
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    edit: contact,
    list,
    search
  }
}
